module.exports = __webpack_public_path__ + "img/questions_icon.aefd54ac.svg";